// extracted by mini-css-extract-plugin
export var contentBody = "_5s-9";
export var headerImage = "_5s-2";
export var imageButton = "_5s-7";
export var imageButtonIcon = "_5s-8";
export var imageHeader = "_5s-4";
export var imageHeaderText = "_5s-5";
export var imageOverlay = "_5s-3";
export var imageTitle = "_5s-6";
export var imageWrapper = "_5s-1";
export var taskList = "_5s-a";
export var widget = "_5s-0";